<div *ngIf="powerEnable; else elseBlockCredit">
    <div class="card">
        <div class="card-header">
            Catalogos Poderes
        </div>
    
        <div class="card-body">
            
            <div class="row">
                <div class="col-12">
    
                    <!-- <p>
                        You can use alternative markup without <code>&lt;ul&gt; &lt;li&gt;</code> elements. You can also interchange
                        <code>&lt;button&gt;</code> and <code>&lt;a&gt;</code> elements for links.
                    </p> -->
                    
                    <nav ngbNav #nav="ngbNav" class="nav-tabs">
    
                        <ng-container ngbNavItem>
                            <a ngbNavLink>Extension</a>
                            <ng-template ngbNavContent>
                                <div class="col-md-6">
                                    <h4>Extension de Poderes</h4>
                                    <h6>Define las extension que puede tener un poder</h6>
                                    <app-power-catalog-element [url_path]="'power-extension'" [element_settings]="settingsPowerCatalogElementExtension"></app-power-catalog-element>
                                </div>
                            </ng-template>
                        </ng-container>
                        <ng-container ngbNavItem>
                            <a ngbNavLink>Tipo</a>
                            <ng-template ngbNavContent>
                                <div class="col-md-6">
                                    <h4>Tipos de Poderes</h4>
                                    <h6>Define los diferentes tipos de poderes.</h6>
                                    
                                    <app-power-catalog-element [url_path]="'power-type'" [element_settings]="settingsPowerCatalogElementType"></app-power-catalog-element>
                                </div>
                            </ng-template>
                        </ng-container>
    
                        <ng-container ngbNavItem>
                            <a ngbNavLink>Atributos</a>
                            <ng-template ngbNavContent>
                                <div class="col-md-6">
                                    <h4>Atributos de Poderes</h4>
                                    <h6>Define los diferentes artibutos de poderes.</h6>
                                    <app-power-catalog-element [url_path]="'power-attributes'" [element_settings]="settingsPowerCatalogElementAttribute"></app-power-catalog-element>
                                </div>
                            </ng-template>
                        </ng-container>

                        <ng-container ngbNavItem>
                            <a ngbNavLink>Notarios</a>
                            <ng-template ngbNavContent>
                                <div class="col-md-6">
                                    <h4>Notarios para Poderes</h4>
                                    <h6>Define los notarios para la seccion de poderes.</h6>
                                    <app-power-catalog-element [url_path]="'public-notaries'" [element_settings]="settingsPowerCatalogElemantPublicNotary"></app-power-catalog-element>
                                </div>
                            </ng-template>
                        </ng-container>                        
                        
                    </nav>
                    
                    <div [ngbNavOutlet]="nav" class="mt-6"></div>
    
                </div>
            </div>
    
        </div>
    </div>

</div>
<ng-template #elseBlockCredit>
    <p class="text-danger">No cuentas con funcionalidad para cargar catalogo de poderes</p>
  </ng-template>


